'use es6';

import { useCallback, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { DashboardFloatingAlertStore } from 'dashboard-components/js/shared/DashboardFloatingAlertStore.ts';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { H5 } from 'foundations-components/transitional/components/H5';
import { Button } from 'foundations-components/transitional/components/Button';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { View } from 'foundations-components/components/View';
import * as DashboardRouter from '../lib/dashboard-router';
import { PARTITIONED_DASHBOARD, PRIVATE_DASHBOARD } from '../constants/ForbiddenAssets';
import { Routes } from '../constants/route/DashboardRoute';
import { requestDashboardAccess } from '../data/AccessRequestDAO';
import { trackViewForbiddenDashboard, trackRequestDashboardAccess, trackViewDashboardAccessRequestResponse } from '../../tracking/ForbiddenDashboard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const returnToDefaultDashboard = history => DashboardRouter.route(Routes.DASHBOARD, null, null, history);
const RequestAccessBody = props => {
  const {
    assetType,
    dashboardId,
    history
  } = props;
  const onRequestAccess = useCallback(() => {
    trackRequestDashboardAccess(assetType);
    requestDashboardAccess(dashboardId).then(() => {
      trackViewDashboardAccessRequestResponse(assetType, true);
      DashboardFloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "forbiddenAssets.partitionedDashboard.onRequestSuccess"
        }),
        type: 'success'
      });
    }).catch(() => {
      trackViewDashboardAccessRequestResponse(assetType, false);
      DashboardFloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "forbiddenAssets.partitionedDashboard.onRequestFailure"
        }),
        type: 'danger'
      });
    });
    returnToDefaultDashboard(history);
  }, [dashboardId, assetType, history]);
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "forbiddenAssets.partitionedDashboard.body"
      })
    }), /*#__PURE__*/_jsx(Button, {
      "data-test-id": "request-access-button",
      use: "primary",
      onClick: onRequestAccess,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "forbiddenAssets.partitionedDashboard.buttonLabel"
      })
    })]
  });
};
RequestAccessBody.propTypes = {
  assetType: PropTypes.string.isRequired,
  dashboardId: PropTypes.number.isRequired,
  history: PropTypes.object.isRequired
};
const ForbiddenDashboardPage = ({
  assetType,
  dashboardId
}) => {
  useEffect(() => {
    trackViewForbiddenDashboard(assetType);
  }, [assetType]);
  return /*#__PURE__*/_jsxs(View, {
    as: "div",
    "data-test-id": "forbidden-dashboard-page",
    inlineSize: "550px",
    margin: "auto",
    textAlign: "center",
    children: [/*#__PURE__*/_jsx(Illustration, {
      name: "keys",
      width: "30%",
      marginBlockEnd: "400",
      marginBlockStart: "1300"
    }), /*#__PURE__*/_jsx(H5, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "forbiddenAssets.default.header"
      })
    }), assetType === PARTITIONED_DASHBOARD ? /*#__PURE__*/_jsx(RequestAccessBody, {
      assetType: assetType,
      dashboardId: dashboardId
    }) : assetType === PRIVATE_DASHBOARD ? /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "forbiddenAssets.privateDashboard.body"
      })
    }) : /*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "forbiddenAssets.default.body"
      })
    })]
  });
};
ForbiddenDashboardPage.propTypes = {
  assetType: PropTypes.string,
  dashboardId: PropTypes.number.isRequired
};
export default withRouter(ForbiddenDashboardPage);